import config from 'api/config';
import fetchApi from 'api/fetchApi';

export interface IUserParams {
  userId: number;
  userPassword: string;
}

type TUsersDELETEReturnType = {
  success: boolean;
  message: string;
};

const usersDELETE = async (
  args: IUserParams,
): Promise<TUsersDELETEReturnType> => {
  const response = await fetchApi({
    method: 'DELETE',
    path: `${config.accountsUsers}${args.userId}`,
    payload: { current_password: args.userPassword },
  });

  const { success, status, payload } = response;

  if (success && status === 204) {
    return {
      success: true,
      message: 'User deleted.',
    };
  }
  if (payload instanceof Object) {
    let message = '';
    Object.entries(payload).forEach((entry) => {
      const [name, val] = entry as [string, string | string[]];
      message += `${name.toUpperCase()} - ${
        val instanceof Array ? val.join('') : JSON.stringify(val)
      } `;
    });
    message = message ? `Errors! ${message}` : 'Something went wrong';
    return {
      success: false,
      message,
    };
  }
  return {
    success: false,
    message: 'Something went wrong',
  };
};

export default usersDELETE;
